import RoutePanel from "./RoutePanel";

// "Routen erleben" — Themenrouten drawn as lines on the map
const routeModule = {
  fallbackLabel: "Themenrouten",
  Panel: RoutePanel,
};

export default routeModule;
